// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2F8Sq","buttons":"RemoveExpirationActionButtons_buttons__30Eqn"};